import React from 'react';
import { WrapPageElementBrowserArgs } from 'gatsby';
import MainLayout from './src/components/features/MainLayout/MainLayout';
import './src/styles/index.css';

export const wrapPageElement = ({ element }: WrapPageElementBrowserArgs) => {
  return <MainLayout>{element}</MainLayout>;
};
